import { fromNow } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useOpenNonCompliancesCountByPlaceId } from '../_load/OpenNonCompliancesCountsLoader'
import { usePlacesAvailability } from '../_load/PlacesAvailabilityLoader'
import { useAvailabilityActionsList } from '../../_actions/useAvailabilityActionsList'
import AvailabilityPlaceCell from './AvailabilityPlaceCell'
import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { TableColumn, genFormattedColumn, useRowActionsColumn } from '../../../../components/tables/Table'
import AvailabilityStatusTag from '../../_shared/AvailabilityStatusTag'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import { SmallText } from '../../../../components/presentation/Text'

const AvailabilityTable = () => {
  const { t } = useTranslation('availability')
  const data = usePlacesAvailability()
  const countByPlaceId = useOpenNonCompliancesCountByPlaceId()

  const columns = [
    {
      label: t('place'),
      headerSideContent: <RefetchingIndicator />,
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 3,
      render: (value, record) => <AvailabilityPlaceCell place={record} />
    },

    {
      label: t('status'),
      dataIndex: 'availabilityStatus',
      sortIndex: false,
      flex: 1.5,
      render: value => <AvailabilityStatusTag status={value} />
    },

    {
      label: t('openNonCompliances'),
      dataIndex: 'id',
      sortIndex: false,
      flex: 1.5,
      render: (id, record) => <TableColumn strong>{countByPlaceId[record.id] ?? 0}</TableColumn>
    },

    {
      label: t('origin'),
      dataIndex: 'availabilityStatusOrigin',
      sortIndex: false,
      flex: 2,
      render: value => <TableColumn>{value ? t(`origin.${value}`) : '—'}</TableColumn>
    },

    {
      label: t('changedAt'),
      dataIndex: 'availabilityStatusChangedAt',
      sortIndex: false,
      flex: 1.5,
      render: genFormattedColumn(value => (value ? fromNow(value) : t('neverChanged')))
    },

    {
      label: t('responsible'),
      dataIndex: 'locks',
      sortIndex: false,
      flex: 1.5,
      render: locks => <SmallText color="dark3">{locks?.[0]?.createdBy?.name || t('noResponsible')}</SmallText>
    },

    {
      label: t('common:actions'),
      flex: 1,
      sortIndex: false,
      render: useRowActionsColumn(useAvailabilityActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" data={data} inPanel />
}

export default AvailabilityTable
